/**
 * The playback queue.
 *
 * Channel up/down needs the list the user was actually looking at — the
 * filtered, searched, country-scoped one — and that list can be 20k rows long,
 * so it cannot ride in the URL. A module-level handoff is enough: the browse
 * screen publishes just before navigating, the player reads it once on mount,
 * and nothing else in the app depends on it.
 */

import type { Kind } from '@sflx/shared';

export interface QueueEntry {
  accountId: string;
  kind: Kind;
  xtreamId: number;
  name: string;
}

let queue: QueueEntry[] = [];

export function setPlaybackQueue(entries: QueueEntry[]): void {
  queue = entries;
}

export function getPlaybackQueue(): QueueEntry[] {
  return queue;
}

/**
 * The neighbour `delta` steps from the given item, or null when the item is not
 * in the queue (the user arrived by deep link) or the queue has one entry.
 */
export function queueNeighbour(accountId: string, xtreamId: number, delta: number): QueueEntry | null {
  if (queue.length < 2) return null;
  const index = queue.findIndex((entry) => entry.accountId === accountId && entry.xtreamId === xtreamId);
  if (index === -1) return null;
  const next = (index + delta + queue.length) % queue.length;
  return queue[next] ?? null;
}
